import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgLopetto = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        d="M7.833 11.167a1.667 1.667 0 1 0 0-3.334 1.667 1.667 0 0 0 0 3.334M16.167 11.167a1.667 1.667 0 1 0 0-3.334 1.667 1.667 0 0 0 0 3.334"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M12.75 3.667V2a.75.75 0 0 0-1.5 0v1.667H6.286A4.29 4.29 0 0 0 2 7.966v7.165a4.295 4.295 0 0 0 3.75 4.265c0 .005.195.01.536.013v1.873c0 .639.77.958 1.22.507l3.69-2.364c2.756.005 4.877.005 6.06.005h.458A4.29 4.29 0 0 0 22 15.13V7.967a4.29 4.29 0 0 0-4.286-4.3zM5.926 17.904H5.9a2.796 2.796 0 0 1-2.4-2.773V7.966a2.79 2.79 0 0 1 2.786-2.8h11.428a2.79 2.79 0 0 1 2.786 2.8v7.165a2.79 2.79 0 0 1-2.786 2.799h-.457c-1.183 0-3.303 0-6.059-.005l-.44-.001-2.972 1.904v-1.903l-1.484-.015z"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgLopetto;
